import {
	mdiTextBoxCheckOutline,
	mdiViewGridOutline,
	mdiTextBoxOutline,
	mdiTextBoxRemoveOutline,
	mdiPlaylistCheck,
	mdiPrinter,
	mdiPlus,
	mdiInboxFullOutline,
	mdiClipboardClockOutline,
	mdiProgressCheck,
	mdiTextBoxCheck,
	mdiPackageVariantClosed,
	mdiCheckAll,
	mdiTrainCar,
	mdiCityVariant,
	mdiAccountOff,
	mdiCallMissed,
	mdiRadar,
	mdiFileDocumentEdit,
	mdiAccountBoxOutline,
	mdiDatabaseArrowLeftOutline,
	mdiDatabaseArrowRightOutline,
	mdiMapMarker,
} from '@mdi/js'

import {
	GET_ALL_ORDERS,
	GET_BILTY_OPS,
	GET_ALL_BILTY_OPS,
	GET_ALL_USERTYPES,
	GET_ALL_REGIONS,
	GET_ALL_TRACKERS,
	GET_JOB_TYPE_STATUS,
	GET_TRACKER_JOBS,
} from '../graphql/query'

import {
	MATCH_ORDER_TO_JOB,
	CREATE_BILTY_OPS,
	UPDATE_BILTY_OPS,
	SWAP_USER_USERTYPE,
	UPDATE_USER_USERTYPE,
	INSERT_BILTY_REGIONS,
	DELETE_BILTY_REGIONS,
	UPDATE_DRIVER,
	UPDATE_TRACKER,
	CREATE_TRACKER,
	UPDATE_BILTIES,
	UPDATE_JOB,
	CREATE_STATUS,
} from '../graphql/mutation'

import { BILTY_OPS_UPDATED, SUBSCRIBE_ORDERS, SUBSCRIBE_JOBS } from '../graphql/subscriptions'

import {
	useCreateBilty,
	useCompleteBilty,
	useCreateLotBilty,
	useCreateTracker,
	useMarkTrackingComplete,
	useEditBilty,
	useMissingKantaInfo,
	useCancelBilty,
	useAssignVicinities,
	useSaveBilty,
	useMarkOrderComplete,
} from '../hooks/modalFinishHooks'
import {
	ConfigureOrderDetails,
	CreateBiltyInformation,
	BiltyCreationResponse,
	PrintBiltyModal,
	PostCreationBiltyInformation,
	DetailsColumn,
	AddMissingKanta,
	CancelBilty,
	SaveBiltyModal,
	MarkOrderComplete,
} from '../components/modals/BiltyManagementModals'
import { MarkTrackingComplete } from '../components/modals/BiltyTrackingModals'
import { setFieldsAddMissingKanta, setFieldsCompleteBilty, setFieldsEditBilty } from '../utils/ModalFunctions'
import { AssignVicinitiesModal } from '../components/modals/UserManagementModals'
import { CreateTrackerModal } from '../components/modals/TrackerManagementModals'

export const GraphQlEnum = {
	Import: {
		key: 'Import',
		parentType: 'ParentImport',
		childrenType: 'SubImports',
		childType: 'SubImport',
		fetch: {
			normal: {
				atom: 'importOrdersAtom',
				queryName: GET_ALL_ORDERS,
				queryOutput: 'orders',
				getVariables: ({ segment, filterKey, filterValue }) => ({
					options: { sort: [{ createdAt: 'DESC' }] },
					where: {
						type: segment,
						...(filterKey === 'dateRange' && { createdAt_GTE: filterValue?.[0]?.format(), createdAt_LTE: filterValue?.[1]?.format() }),
						...(filterKey === 'businessName' && { businessCode: filterValue }),
						ParentOrder: {
							...(['driverVehicleRegistration', 'driverPhone', 'biltyNumber', 'jobNumber']?.includes(filterKey) && {
								Movements_SOME: {
									Job: {
										...(filterKey === 'jobNumber' && {
											jobNumber: parseFloat(filterValue),
										}),
										...(filterKey === 'driverPhone' && {
											Driver: {
												phoneNumber_CONTAINS: filterValue,
											},
										}),
										...(filterKey === 'driverVehicleRegistration' && {
											Vehicle: {
												registrationNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()],
											},
										}),
										...(filterKey === 'biltyNumber' && {
											bilty_SOME: {
												biltyNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()],
											},
										}),
									},
								},
							}),
							[GraphQlEnum[segment]?.parentType]: {
								...(['Import', 'Export']?.includes(segment) &&
									filterKey === 'documentNumber' && { documentNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()] }),
								[`${[GraphQlEnum[segment]?.childrenType]}_SOME`]: {
									...(filterKey === 'subOrderNumber' && { subOrderNumber_CONTAINS: filterValue?.toUpperCase() }),
									...(segment !== 'LongHaul' &&
										filterKey === 'containerNumber' && { containerNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()] }),
									status_IN: ['Order Confirmed', 'Partial Ongoing', 'Partial Completed', 'Order Ongoing', 'Order Completed'],
								},
							},
						},
					},
					movementsWhere2: {
						ChildOrder: {
							[GraphQlEnum[segment]?.childType]: {
								status_IN: ['Order Confirmed', 'Partial Ongoing', 'Partial Completed', 'Order Ongoing', 'Order Completed'],
							},
						},
					},
					biltyOptions2: {
						sort: [
							{
								createdAt: 'DESC',
							},
						],
					},
				}),
			},
			alternate: {
				atom: 'importJobsAtom',
				queryName: GET_JOB_TYPE_STATUS,
				queryOutput: 'jobs',
				getVariables: ({ status }) => {
					const types = [
						{ movementType: 'Import', subMovementType: 'Import' },
						{ movementType: 'ImportShifting', subMovementType: 'LongHaul' },
						{ movementType: 'DoubleTwenty', subMovementType: 'Import' },
					]
					return {
						options: { sort: [{ cancelledAt: 'DESC' }] },
						biltyOptions2: {
							sort: [
								{
									createdAt: 'DESC',
								},
							],
						},
						where: {
							status: status,
							...(status === 'Job Cancelled' && { bilty_SOME: { isCancelled: true } }),
							OR: types?.map((type) => ({ OrderDetails_CONTAINS: `"movementType":"${type?.movementType}","subMovementType":"${type?.subMovementType}"` })),
						},
					}
				},
			},
		},
		listen: {
			normal: {
				subscriptionName: SUBSCRIBE_ORDERS,
				subscriptionOutput: 'OrderUpdatedByChildOrderStatusAndType',
			},
			alternate: {
				subscriptionName: SUBSCRIBE_JOBS,
				subscriptionOutput: 'jobUpdatedByMovementTypeAndStatus',
			},
		},
	},
	Export: {
		key: 'Export',
		parentType: 'ParentExport',
		childrenType: 'SubExports',
		childType: 'SubExport',
		fetch: {
			normal: {
				atom: 'exportOrdersAtom',
				queryName: GET_ALL_ORDERS,
				queryOutput: 'orders',
				getVariables: ({ segment, filterKey, filterValue }) => ({
					options: { sort: [{ createdAt: 'DESC' }] },
					where: {
						type: segment,
						...(filterKey === 'dateRange' && { createdAt_GTE: filterValue?.[0]?.format(), createdAt_LTE: filterValue?.[1]?.format() }),
						...(filterKey === 'businessName' && { businessCode: filterValue }),
						ParentOrder: {
							...(['driverVehicleRegistration', 'driverPhone', 'biltyNumber', 'jobNumber']?.includes(filterKey) && {
								Movements_SOME: {
									Job: {
										...(filterKey === 'jobNumber' && {
											jobNumber: parseFloat(filterValue),
										}),
										...(filterKey === 'driverPhone' && {
											Driver: {
												phoneNumber_CONTAINS: filterValue,
											},
										}),
										...(filterKey === 'driverVehicleRegistration' && {
											Vehicle: {
												registrationNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()],
											},
										}),
										...(filterKey === 'biltyNumber' && {
											bilty_SOME: {
												biltyNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()],
											},
										}),
									},
								},
							}),
							[GraphQlEnum[segment]?.parentType]: {
								...(['Import', 'Export']?.includes(segment) &&
									filterKey === 'documentNumber' && { documentNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()] }),
								[`${[GraphQlEnum[segment]?.childrenType]}_SOME`]: {
									...(filterKey === 'subOrderNumber' && { subOrderNumber_CONTAINS: filterValue?.toUpperCase() }),
									...(segment !== 'LongHaul' &&
										filterKey === 'containerNumber' && { containerNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()] }),
									status_IN: ['Order Confirmed', 'Partial Ongoing', 'Partial Completed', 'Order Ongoing', 'Order Completed'],
								},
							},
						},
					},
					movementsWhere2: {
						ChildOrder: {
							[GraphQlEnum[segment]?.childType]: {
								status_IN: ['Order Confirmed', 'Partial Ongoing', 'Partial Completed', 'Order Ongoing', 'Order Completed'],
							},
						},
					},
					biltyOptions2: {
						sort: [
							{
								createdAt: 'DESC',
							},
						],
					},
				}),
			},
			alternate: {
				atom: 'exportJobsAtom',
				queryName: GET_JOB_TYPE_STATUS,
				queryOutput: 'jobs',
				getVariables: ({ status }) => {
					const types = [
						{ movementType: 'Export', subMovementType: 'Export' },
						{ movementType: 'DoubleTwenty', subMovementType: 'Export' },
					]
					return {
						options: { sort: [{ cancelledAt: 'DESC' }] },
						biltyOptions2: {
							sort: [
								{
									createdAt: 'DESC',
								},
							],
						},
						where: {
							status: status,
							...(status === 'Job Cancelled' && { bilty_SOME: { isCancelled: true } }),
							OR: types?.map((type) => ({ OrderDetails_CONTAINS: `"movementType":"${type?.movementType}","subMovementType":"${type?.subMovementType}"` })),
						},
					}
				},
			},
		},
		listen: {
			normal: {
				subscriptionName: SUBSCRIBE_ORDERS,
				subscriptionOutput: 'OrderUpdatedByChildOrderStatusAndType',
			},
			alternate: {
				subscriptionName: SUBSCRIBE_JOBS,
				subscriptionOutput: 'jobUpdatedByMovementTypeAndStatus',
			},
		},
	},
	LongHaul: {
		key: 'LongHaul',
		parentType: 'ParentLongHaul',
		childrenType: 'SubLongHauls',
		childType: 'SubLongHaul',
		fetch: {
			normal: {
				atom: 'bulkOrdersAtom',
				queryName: GET_ALL_ORDERS,
				queryOutput: 'orders',
				getVariables: ({ segment, filterKey, filterValue }) => ({
					options: { sort: [{ createdAt: 'DESC' }] },
					where: {
						type: segment,
						...(filterKey === 'dateRange' && { createdAt_GTE: filterValue?.[0]?.format(), createdAt_LTE: filterValue?.[1]?.format() }),
						...(filterKey === 'businessName' && { businessCode: filterValue }),
						ParentOrder: {
							...(['driverVehicleRegistration', 'driverPhone', 'biltyNumber', 'jobNumber']?.includes(filterKey) && {
								Movements_SOME: {
									Job: {
										...(filterKey === 'jobNumber' && {
											jobNumber: parseFloat(filterValue),
										}),
										...(filterKey === 'driverPhone' && {
											Driver: {
												phoneNumber_CONTAINS: filterValue,
											},
										}),
										...(filterKey === 'driverVehicleRegistration' && {
											Vehicle: {
												registrationNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()],
											},
										}),
										...(filterKey === 'biltyNumber' && {
											bilty_SOME: {
												biltyNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()],
											},
										}),
									},
								},
							}),
							[GraphQlEnum[segment]?.parentType]: {
								...(['Import', 'Export']?.includes(segment) &&
									filterKey === 'documentNumber' && { documentNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()] }),
								[`${[GraphQlEnum[segment]?.childrenType]}_SOME`]: {
									...(filterKey === 'subOrderNumber' && { subOrderNumber_CONTAINS: filterValue?.toUpperCase() }),
									...(segment !== 'LongHaul' &&
										filterKey === 'containerNumber' && { containerNumber_IN: [filterValue, filterValue?.toUpperCase(), filterValue?.toLowerCase()] }),
									status_IN: ['Order Confirmed', 'Partial Ongoing', 'Partial Completed', 'Order Ongoing', 'Order Completed'],
								},
							},
						},
					},
					movementsWhere2: {
						ChildOrder: {
							[GraphQlEnum[segment]?.childType]: {
								status_IN: ['Order Confirmed', 'Partial Ongoing', 'Partial Completed', 'Order Ongoing', 'Order Completed'],
							},
						},
					},
					biltyOptions2: {
						sort: [
							{
								createdAt: 'DESC',
							},
						],
					},
				}),
			},
			alternate: {
				atom: 'bulkJobsAtom',
				queryName: GET_JOB_TYPE_STATUS,
				queryOutput: 'jobs',
				getVariables: ({ status }) => {
					const types = [{ movementType: 'LongHaul', subMovementType: 'LongHaul' }]
					return {
						options: { sort: [{ cancelledAt: 'DESC' }] },
						biltyOptions2: {
							sort: [
								{
									createdAt: 'DESC',
								},
							],
						},
						where: {
							status: status,
							...(status === 'Job Cancelled' && { bilty_SOME: { isCancelled: true } }),
							OR: types?.map((type) => ({ OrderDetails_CONTAINS: `"movementType":"${type?.movementType}","subMovementType":"${type?.subMovementType}"` })),
						},
					}
				},
			},
		},
		listen: {
			normal: {
				subscriptionName: SUBSCRIBE_ORDERS,
				subscriptionOutput: 'OrderUpdatedByChildOrderStatusAndType',
			},
			alternate: {
				subscriptionName: SUBSCRIBE_JOBS,
				subscriptionOutput: 'jobUpdatedByMovementTypeAndStatus',
			},
		},
	},
	Bilties: {
		updateBilties: {
			function: UPDATE_BILTIES,
			functionInput: 'updateBiltiesInput',
			functionOutput: 'updateBilties',
		},
	},
	Jobs: {
		fetch: {
			normal: {
				atom: 'trackerJobAtom',
				queryName: GET_TRACKER_JOBS,
				queryOutput: 'jobs',
				getVariables: () => ({
					where: {
						status_IN: ['Job Ongoing', 'Job Completed'],
						bilty_NONE: {
							biltyStatus: 'received',
						},
						Tracker_NOT: null,
					},
				}),
			},
		},
		matchOrderToJob: {
			function: MATCH_ORDER_TO_JOB,
			functionInput: 'matchOrderToJobInput',
			functionOutput: 'matchOrderToJob',
		},
		updateJob: {
			function: UPDATE_JOB,
			functionInput: 'updateJobInput',
			functionOutput: 'updateJob',
		},
	},
	User: {
		key: 'User',
		fetch: {
			normal: {
				atom: 'userAtom',
				queryName: GET_BILTY_OPS,
				queryOutput: 'biltyOps',
				getVariables: ({ _id }) => ({ where: { User: { _id: _id } } }),
			},
		},
	},
	BiltyOps: {
		key: 'BiltyOps',
		fetch: {
			normal: {
				atom: 'biltyOpsAtom',
				queryName: GET_ALL_BILTY_OPS,
				queryOutput: 'biltyOps',
			},
		},
		listen: {
			normal: {
				subscriptionName: BILTY_OPS_UPDATED,
				subscriptionOutput: 'biltyOpsUpdated',
			},
		},
		createBiltyOps: {
			function: CREATE_BILTY_OPS,
			functionInput: 'createBiltyOpsInput',
			functionOutput: 'createBiltyOp',
		},
		updateBiltyOps: {
			function: UPDATE_BILTY_OPS,
			functionInput: 'updateBiltyOpsInput',
			functionOutput: 'updateBiltyOp',
		},
		insertBiltyRegions: {
			function: INSERT_BILTY_REGIONS,
			functionInput: 'insertRegionsInput',
			functionOutput: 'insertBiltyRegions',
		},
		deleteBiltyRegions: {
			function: DELETE_BILTY_REGIONS,
			functionInput: 'deleteRegionsInput',
			functionOutput: 'deleteBiltyRegions',
		},
	},
	UserTypes: {
		key: 'UserTypes',
		fetch: {
			normal: {
				atom: 'userTypesAtom',
				queryName: GET_ALL_USERTYPES,
				queryOutput: 'userTypes',
			},
		},
		updateUserTypes: {
			function: UPDATE_USER_USERTYPE,
			functionInput: 'updateUserInput',
			functionOutput: 'updateUser',
		},
		swapUserTypes: {
			function: SWAP_USER_USERTYPE,
			functionInput: 'swapUserInput',
			functionOutput: 'swapUserType',
		},
	},
	Regions: {
		key: 'Regions',
		fetch: {
			normal: {
				atom: 'vicinitiesAtom',
				queryName: GET_ALL_REGIONS,
				queryOutput: 'regions',
			},
		},
	},
	Trackers: {
		key: 'Trackers',
		fetch: {
			normal: {
				atom: 'trackersAtom',
				queryName: GET_ALL_TRACKERS,
				queryOutput: 'trackers',
			},
		},
		updateTracker: {
			function: UPDATE_TRACKER,
			functionInput: 'where',
			functionInput2: 'update',
			functionOutput: 'updateTrackers',
		},
		createTracker: {
			function: CREATE_TRACKER,
			functionInput: 'input',
			functionOutput: 'createTrackers',
		},
	},
	Drivers: {
		key: 'Drivers',
		updateDriver: {
			function: UPDATE_DRIVER,
			functionInput: 'updateDriverInput',
			functionOutput: 'updateDriver',
		},
	},
	Status: {
		updateStatus: {
			function: CREATE_STATUS,
			functionInput: 'createStatusInput',
			functionOutput: 'createStatus',
		},
	},
}

export const BiltyStatusEnum = {
	issuance: {
		key: 'issuance',
		text: 'Issuance',
		icon: mdiViewGridOutline,
		biltyActionText: 'Create Bilty',
		biltyActionIcon: mdiPlus,
		biltyActionModal: 'createBilty',
	},
	inProgress: {
		key: 'inProgress',
		text: 'In Progress',
		icon: mdiTextBoxOutline,
		biltyActionText: 'Complete Bilty',
		biltyActionIcon: mdiPlaylistCheck,
		biltyActionModal: 'completeBilty',
	},
	completed: {
		key: 'completed',
		text: 'Completed',
		icon: mdiTextBoxCheckOutline,
		biltyActionText: 'Edit Bilty',
		biltyActionIcon: mdiFileDocumentEdit,
		biltyActionModal: 'editBilty',
	},
	cancelled: {
		key: 'cancelled',
		text: 'Cancelled',
		icon: mdiTextBoxRemoveOutline,
		biltyActionText: 'Print Bilty',
		biltyActionIcon: mdiPrinter,
		biltyActionModal: 'printBilty',
	},
}

export const SegmentsEnum = {
	Import: {
		key: 'Import',
		text: 'Import',
		long: 'Import Orders',
		initial: 'I',
		documentType: 'BL Number',
		documentTypeShort: 'BL#',
		jobType: 'import/export',
		collectionName: 'import_export',
		atom: 'importOrdersAtom',
		icon: mdiViewGridOutline,
		filterProperties: {
			Import: [
				'subOrderNumber',
				'jobNumber',
				'biltyNumber',
				'driverPhone',
				'driverVehicleRegistration',
				'documentNumber',
				'containerNumber',
				'businessName',
			],
			issuance: ['subOrderNumber', 'documentNumber', 'containerNumber', 'businessName'],
			inProgress: [
				'subOrderNumber',
				'jobNumber',
				'biltyNumber',
				'driverPhone',
				'driverVehicleRegistration',
				'documentNumber',
				'containerNumber',
				'businessName',
			],
			completed: [
				'subOrderNumber',
				'jobNumber',
				'biltyNumber',
				'driverPhone',
				'driverVehicleRegistration',
				'documentNumber',
				'containerNumber',
				'businessName',
			],
			cancelled: ['biltyNumber', 'jobNumber', 'driverPhone', 'driverVehicleRegistration'],
		},
	},
	Export: {
		key: 'Export',
		text: 'Export',
		long: 'Export Orders',
		initial: 'E',
		documentType: 'CRO Number',
		documentTypeShort: 'CRO#',
		jobType: 'import/export',
		collectionName: 'import_export',
		atom: 'exportOrdersAtom',
		icon: mdiTextBoxOutline,
		filterProperties: {
			Export: [
				'subOrderNumber',
				'jobNumber',
				'biltyNumber',
				'driverPhone',
				'driverVehicleRegistration',
				'documentNumber',
				'containerNumber',
				'businessName',
			],
			issuance: ['subOrderNumber', 'documentNumber', 'containerNumber', 'businessName'],
			inProgress: [
				'subOrderNumber',
				'jobNumber',
				'biltyNumber',
				'driverPhone',
				'driverVehicleRegistration',
				'documentNumber',
				'containerNumber',
				'businessName',
			],
			completed: [
				'subOrderNumber',
				'jobNumber',
				'biltyNumber',
				'driverPhone',
				'driverVehicleRegistration',
				'documentNumber',
				'containerNumber',
				'businessName',
			],
			cancelled: ['biltyNumber', 'jobNumber', 'driverPhone', 'driverVehicleRegistration'],
		},
	},
	LongHaul: {
		key: 'LongHaul',
		text: 'Bulk',
		long: 'Bulk Orders',
		initial: 'L',
		documentTypeShort: 'Selected Orders',
		jobType: 'longHaul',
		collectionName: 'long_haul',
		atom: 'bulkOrdersAtom',
		icon: mdiTextBoxCheckOutline,
		filterProperties: {
			LongHaul: ['subOrderNumber', 'jobNumber', 'biltyNumber', 'driverPhone', 'driverVehicleRegistration', 'businessName'],
			issuance: ['subOrderNumber', 'businessName'],
			inProgress: ['subOrderNumber', 'jobNumber', 'biltyNumber', 'driverPhone', 'driverVehicleRegistration', 'businessName'],
			completed: ['subOrderNumber', 'jobNumber', 'biltyNumber', 'driverPhone', 'driverVehicleRegistration', 'businessName'],
			cancelled: ['biltyNumber', 'jobNumber', 'driverPhone', 'driverVehicleRegistration'],
		},
	},
}

export const SearchSegmentsEnum = {
	...SegmentsEnum,
	BiltyOps: {
		key: 'BiltyOps',
		text: 'Users',
		long: 'Users',
		initial: 'U',
		collectionName: 'bilty_ops',
		atom: 'biltyOpsAtom',
		icon: mdiTextBoxCheckOutline,
		filterProperties: ['userName', 'email', 'phoneNumber'],
	},
	Trackers: {
		key: 'Trackers',
		text: 'Trackers',
		long: 'Trackers',
		initial: 'T',
		collectionName: 'bilty_ops',
		atom: 'trackersAtom',
		icon: mdiTextBoxCheckOutline,
		filterProperties: ['name', 'provider', 'driver', 'vehicle'],
	},
}

export const PagesEnum = {
	biltyManagementImport: {
		key: 'biltyManagementImport',
		orderType: 'Import',
		text: 'Import Bilties',
		tabsEnum: BiltyStatusEnum,
		showSearch: true,
		allowedSegments: ['Import'],
		showTimeFilter: true,
		showAdvancedSearch: true,
	},
	biltyManagementExport: {
		key: 'biltyManagementExport',
		orderType: 'Export',
		text: 'Export Bilties',
		tabsEnum: BiltyStatusEnum,
		showSearch: true,
		allowedSegments: ['Export'],
		showTimeFilter: true,
		showAdvancedSearch: true,
	},
	biltyManagementLongHaul: {
		key: 'biltyManagementLongHaul',
		orderType: 'LongHaul',
		text: 'Bulk Bilties',
		tabsEnum: BiltyStatusEnum,
		showSearch: true,
		allowedSegments: ['LongHaul'],
		showTimeFilter: true,
		showAdvancedSearch: true,
	},
	biltyTracking: {
		key: 'biltyTracking',
		orderType: 'Import',
		text: 'Bilty Tracking',
		tabsEnum: SegmentsEnum,
		showSearch: true,
		allowedSegments: ['Import', 'Export', 'LongHaul'],
		showTimeFilter: true,
		showAdvancedSearch: true,
	},
	userManagement: {
		key: 'userManagement',
		orderType: 'BiltyOps',
		text: 'User Management',
		tabsEnum: undefined,
		showSearch: true,
		allowedSegments: ['BiltyOps'],
		showTimeFilter: false,
		showAdvancedSearch: false,
	},
	trackerManagement: {
		key: 'trackerManagement',
		orderType: 'Trackers',
		text: 'Tracker Management',
		tabsEnum: undefined,
		showSearch: true,
		allowedSegments: ['Trackers'],
		showTimeFilter: false,
		showAdvancedSearch: false,
	},
}

export const ContainerDimensionsEnum = {
	xl20ft: { key: 'xl20ft', text: '20 Ft Container', long: '20 Feet', small: '20 ft', icon: '#xl20ft' },
	xl40ft: { key: 'xl40ft', text: '40 Ft Container', long: '40 Feet', small: '40 ft', icon: '#xl40ft' },
	xl40ftHC: { key: 'xl40ftHC', text: '40 Ft High Cube Container', long: '40 Feet - High Cube', small: '40 ft HC', icon: '#xl40ftHC' },
	xl40ftOT: { key: 'xl40ftOT', text: '40 Ft Open Top Container', long: '40 Feet - Open Top', small: '40 ft OT', icon: '#xl40ftOT' },
	flatbed: { key: 'flatbed', text: 'Flatbed', long: 'Flatbed', small: 'Flatbed', icon: '#flatbed' },
	other: { key: 'other', text: 'Other', long: 'Other Container', small: 'other', icon: '#other' },
}

export const LocationEnums = {
	'Empty Container Pickup': { key: 'Empty Container Pickup', text: 'EMPTY CONTAINER PICKUP', icon: mdiMapMarker, color: '!bg-[#37AC3C]' },
	Yard: { key: 'Yard', text: 'YARD', icon: mdiMapMarker, color: '!bg-[#1C75BC]' },
	loading: { key: 'loading', text: 'LOADING', icon: mdiMapMarker, color: '!bg-[#1C75BC]' },
	dropoff: { key: 'dropoff', text: 'DROP-OFF', icon: mdiMapMarker, color: '!bg-[#DC473C]' },
	'Empty Container Dropoff': { key: 'Empty Container Dropoff', text: 'EMPTY CONTAINER DROPOFF', icon: mdiMapMarker, color: '!bg-[#37AC3C]' },
}

export const SidebarEnum = {
	biltyManagement: {
		key: 'biltyManagement',
		text: 'Document Management',
		icon: mdiInboxFullOutline,
		children: [
			{ key: 'Import', text: 'Import Orders', path: '/biltyManagement/Import', icon: mdiDatabaseArrowLeftOutline },
			{ key: 'Export', text: 'Export Orders', path: '/biltyManagement/Export', icon: mdiDatabaseArrowRightOutline },
			{ key: 'LongHaul', text: 'Bulk Orders', path: '/biltyManagement/LongHaul', icon: mdiInboxFullOutline },
		],
	},
	tracking: {
		key: 'biltyTracking',
		text: 'Bilty Tracking',
		icon: mdiClipboardClockOutline,
		path: '/biltyTracking',
	},
	userManagement: {
		key: 'userManagement',
		text: 'User Management',
		icon: mdiAccountBoxOutline,
		path: '/userManagement',
	},
	trackerManagement: {
		key: 'trackerManagement',
		text: 'Tracker Management',
		icon: mdiRadar,
		path: '/trackerManagement',
	},
}

export const BiltyTrackingEnum = {
	notReceived: { key: 'notReceived', text: 'Not Received', background: 'BackgroundBlueGraySilver', textColor: 'WhiteColor', icon: mdiProgressCheck },
	received: { key: 'received', text: 'Received', background: 'BackgroundMoneyColor', textColor: 'WhiteColor', icon: mdiTextBoxCheck },
	viaTCS: { key: 'viaTCS', text: 'Via TCS', background: 'BackgroundMustardColor', textColor: 'WhiteColor', icon: mdiPackageVariantClosed },
	lost: { key: 'lost', text: 'Lost', background: 'BackgroundErrorColor', textColor: 'WhiteColor', icon: mdiTextBoxRemoveOutline },
	submittedToTransporter: {
		key: 'submittedToTransporter',
		text: 'Submitted To Transporter',
		background: 'BackgroundGreenColor',
		textColor: 'WhiteColor',
		icon: mdiTrainCar,
	},
	willSubmitInKarachi: {
		key: 'willSubmitInKarachi',
		text: 'Will Submit In Karachi',
		background: 'BackgroundPurpleColor',
		textColor: 'WhiteColor',
		icon: mdiCityVariant,
	},
	misplacedBilty: {
		key: 'misplacedBilty',
		text: 'Misplaced Bilty',
		background: 'BackgroundLightBlueColor',
		textColor: 'WhiteColor',
		icon: mdiCallMissed,
	},
	driverNotResponding: {
		key: 'driverNotResponding',
		text: 'Driver Not Responding',
		background: 'BackgroundOrangeColor',
		textColor: 'WhiteColor',
		icon: mdiAccountOff,
	},
	completed: { key: 'completed', text: 'Completed', background: 'BackgroundPrimaryColor', textColor: 'WhiteColor', icon: mdiCheckAll },
}

export const UserTypesEnum = {
	User: { key: 'User', text: 'User', background: 'BackgroundBlueGraySilver' },
	BaseManager: { key: 'BaseManager', text: 'Base Manager', background: 'BackgroundMoneyColor' },
	BiltyAdmin: { key: 'Admin', text: 'Admin', background: 'BackgroundMustardColor' },
	BiltySuperAdmin: { key: 'SuperAdmin', text: 'Super Admin', background: 'BackgroundErrorColor' },
}

export const SearchoptionsEnum = {
	subOrderNumber: { key: 'subOrderNumber', value: 'Order Number' },
	jobNumber: { key: 'jobNumber', value: 'Job Number' },
	driverPhone: { key: 'driverPhone', value: 'Driver Phone' },
	driverVehicleRegistration: { key: 'driverVehicleRegistration', value: 'Vehicle Number' },
	businessName: { key: 'businessName', value: 'Client' },
	containerNumber: { key: 'containerNumber', value: 'Container Number' },
	documentNumber: { key: 'documentNumber', value: 'Document Number' },
	biltyNumber: { key: 'biltyNumber', value: 'Bilty Number' },
	userName: { key: 'userName', value: 'Full Name' },
	phoneNumber: { key: 'phoneNumber', value: 'Phone Number' },
	email: { key: 'email', value: 'Email' },
}

export const VehicleTypeEnums = {
	'Flatbed-Large': { key: 'Flatbed-Large', text: '45ft Flatbed', long: '45 Feet Flatbed', icon: '#other' },
	'Flatbed-Medium': { key: 'Flatbed-Medium', text: '43ft Flatbed', long: '43 Feet Flatbed', icon: '#other' },
	'Flatbed-Small': { key: 'Flatbed-Small', text: 'Small Flatbed', long: 'Small Flatbed', icon: '#other' },
	'Lowbed-Standard': { key: 'Lowbed-Standard', text: 'Lowbed', icon: '' },
	'Lowbed-MultiAxle': { key: 'Lowbed-MultiAxle', text: 'Multi-Axle Lowbed', icon: '' },
	'Trolly-xl20ft': { key: 'Trolly-xl20ft', text: '20 Ft', long: '20 Feet Trolly', icon: '#xl20ft' },
	'Trolly-xl40ft': { key: 'Trolly-xl40ft', text: '40 Ft', long: '40 Feet Trolly', icon: '#xl40ft' },
	'Trolly-xl2020ft': { key: 'Trolly-xl2020ft', text: 'Double Twenty', long: 'Double Twenty', icon: '#xl40ft' },
	Mazda: { key: 'Mazda', text: 'Mazda', long: 'Mazda', icon: '#other' },
	dumper: { key: 'dumper', text: 'Dumper', icon: '#dumper' },
	halfBody: { key: 'halfBody', text: 'Half Body', icon: '#halfBody' },
	other: { key: 'other', text: 'Other', long: 'Other', icon: '#other' },
}

export const orderCategoryEnum = {
	Shifting: { key: 'Shifting', text: 'Shifting', background: 'bg-[#F5C002]' },
	Destuffing: { key: 'Destuffing', text: 'De-stuffing', background: 'bg-[#3C7D8B]' },
	DoubleTwenty: { key: 'DoubleTwenty', text: 'Double Twenty', background: 'bg-[#1C75BC]' },
}

export const PageSizes = {
	10: { frontend: 10, backend: 20 },
	20: { frontend: 20, backend: 40 },
	50: { frontend: 50, backend: 100 },
	100: { frontend: 100, backend: 200 },
}

export const RBACEnum = {
	BiltySuperAdmin: {
		collections: ['biltyManagement', 'biltyTracking', 'userManagement', 'trackerManagement'],
		trackingOptions: [
			'notReceived',
			'received',
			'viaTCS',
			'lost',
			'submittedToTransporter',
			'willSubmitInKarachi',
			'misplacedBilty',
			'driverNotResponding',
			'completed',
		],
	},
	BiltyAdmin: {
		collections: ['biltyManagement', 'biltyTracking', 'trackerManagement'],
		trackingOptions: [
			'notReceived',
			'received',
			'viaTCS',
			'submittedToTransporter',
			'willSubmitInKarachi',
			'misplacedBilty',
			'driverNotResponding',
			'completed',
		],
	},
	BaseManager: {
		collections: ['biltyManagement', 'trackerManagement'],
	},
}

export const ModalEnums = {
	createBilty: ({ segment, isLot }) => ({
		title: 'Create Bilty',
		showTimeline: true,
		resetFormValues: ({
			form,
			props: {
				data: { job },
			},
		}) => {
			if (isLot) {
				form.setFieldsValue({
					driverName: job?.Driver?.name,
					driverPhone: job?.Driver?.phoneNumber?.replace('+92', ''),
					driverCNIC: job?.Driver?.cnic,
					driverVehicleRegistration: job?.Vehicle?.registrationNumber,
					driverCNICDocument: job?.Driver?.cnicDocument?.map((doc, index) => {
						return { uid: `${index + 1}`, name: `driverCNICDocument`, status: 'done', url: doc }
					}),
				})
			}
		},
		customResultPage: {
			width: 700,
			columns: [{ widthClassName: 'w-[100%]', element: BiltyCreationResponse }],
		},
		pages: [
			{
				title: `Configure ${segment === 'LongHaul' ? 'Orders' : 'Containers'}`,
				watchField: 'all',
				width: 725,
				columns: [{ widthClassName: 'w-[100%]', element: ConfigureOrderDetails }],
				buttons: [
					{ type: 'cancel', title: 'CANCEL', className: 'btn-delete' },
					{ type: 'validateNext', title: 'Next', className: 'btn-primary' },
				],
			},
			{
				title: 'Bilty Information',
				watchField: 'all',
				width: 950,
				columns: [
					{ widthClassName: 'w-[250px]', element: DetailsColumn },
					{ widthClassName: 'w-[700px]', element: CreateBiltyInformation },
				],
				useFinishFunction: isLot ? useCreateLotBilty : useCreateBilty,
				buttons: [
					{ type: 'back', title: 'GO BACK', className: 'btn-back' },
					{ type: 'submit', title: 'SUBMIT DETAILS', className: 'btn-primary' },
				],
			},
		],
	}),
	completeBilty: () => ({
		title: '',
		resetFormValues: ({ form, props }) => {
			const initialValues = setFieldsCompleteBilty(props)
			form.setFieldsValue(initialValues)
		},
		pages: [
			{
				title: 'Complete Bilty',
				watchField: 'all',
				width: 950,
				columns: [
					{ widthClassName: 'w-[250px]', element: DetailsColumn },
					{ widthClassName: 'w-[700px]', element: PostCreationBiltyInformation },
				],
				useFinishFunction: useCompleteBilty,
				buttons: [
					{ type: 'cancel', title: 'CANCEL', className: 'btn-delete' },
					{ type: 'submit', title: 'SUBMIT DETAILS', className: 'btn-primary' },
				],
			},
		],
	}),
	editBilty: () => ({
		title: '',
		resetFormValues: ({ form, props }) => {
			const initialValues = setFieldsEditBilty(props)
			form.setFieldsValue(initialValues)
		},
		pages: [
			{
				title: 'Edit Bilty',
				watchField: 'all',
				width: 950,
				columns: [
					{ widthClassName: 'w-[250px]', element: DetailsColumn },
					{ widthClassName: 'w-[700px]', element: PostCreationBiltyInformation },
				],
				useFinishFunction: useEditBilty,
				buttons: [
					{ type: 'cancel', title: 'CANCEL', className: 'btn-delete' },
					{ type: 'submit', title: 'SUBMIT DETAILS', className: 'btn-primary' },
				],
			},
		],
	}),
	cancelBilty: () => ({
		pages: [
			{
				title: 'Cancel Bilty',
				watchField: 'all',
				width: 700,
				columns: [{ widthClassName: 'w-[100%]', element: CancelBilty }],
				useFinishFunction: useCancelBilty,
				buttons: [
					{ type: 'cancel', title: 'Close', className: 'btn-delete' },
					{ type: 'submit', title: 'SUBMIT DETAILS', className: 'btn-primary' },
				],
			},
		],
	}),
	printBilty: () => ({
		onlyResultPage: true,
		customResultPage: {
			width: 750,
			columns: [{ widthClassName: 'w-[100%]', element: PrintBiltyModal }],
		},
	}),
	saveBilty: () => ({
		pages: [
			{
				title: 'Generate & Save Bilty',
				watchField: 'all',
				width: 600,
				columns: [{ widthClassName: 'w-[100%]', element: SaveBiltyModal }],
				useFinishFunction: useSaveBilty,
				buttons: [
					{ type: 'cancel', title: 'Close', className: 'btn-delete' },
					{ type: 'submit', title: 'GENERATE', className: 'btn-primary' },
				],
			},
		],
	}),
	missingKanta: () => ({
		resetFormValues: ({ form, props: { data: record } }) => {
			const setValues = setFieldsAddMissingKanta(record)
			form.setFieldsValue(setValues)
		},
		pages: [
			{
				title: 'Add Missing Kanta',
				width: 700,
				columns: [{ widthClassName: 'w-[100%]', element: AddMissingKanta }],
				buttons: [
					{ type: 'cancel', title: 'Close', className: 'btn-delete' },
					{ type: 'submit', title: 'SUBMIT DETAILS', className: 'btn-primary' },
				],
				useFinishFunction: useMissingKantaInfo,
			},
		],
	}),
	markOrderComplete: () => ({
		pages: [
			{
				title: 'Mark Order Complete',
				width: 650,
				columns: [{ widthClassName: 'w-[100%]', element: MarkOrderComplete }],
				buttons: [
					{ type: 'cancel', title: 'Close', className: 'btn-delete' },
					{ type: 'submit', title: 'Complete Order', className: 'btn-primary' },
				],
				useFinishFunction: useMarkOrderComplete,
			},
		],
	}),
	markTrackingComplete: () => ({
		pages: [
			{
				title: 'Mark Tracking Complete',
				width: 550,
				columns: [{ widthClassName: 'w-[100%]', element: MarkTrackingComplete }],
				buttons: [
					{ type: 'cancel', title: 'Close', className: 'btn-delete' },
					{ type: 'submit', title: 'Complete Tracking', className: 'btn-primary' },
				],
				useFinishFunction: useMarkTrackingComplete,
			},
		],
	}),
	assignVicinities: () => ({
		pages: [
			{
				title: 'Assign Vicinities',
				width: 700,
				columns: [{ widthClassName: 'w-[100%]', element: AssignVicinitiesModal }],
				buttons: [
					{ type: 'cancel', title: 'Close', className: 'btn-delete' },
					{ type: 'submit', title: 'Submit', className: 'btn-primary' },
				],
				useFinishFunction: useAssignVicinities,
			},
		],
	}),
	createTracker: () => ({
		pages: [
			{
				title: 'Add New Tracker',
				width: 600,
				columns: [{ widthClassName: 'w-[100%]', element: CreateTrackerModal }],
				buttons: [
					{ type: 'cancel', title: 'Close', className: 'btn-delete' },
					{ type: 'submit', title: 'Submit', className: 'btn-primary' },
				],
				useFinishFunction: useCreateTracker,
			},
		],
	}),
}
